<app-card id="detalheItem" [title]="titulo + ' item'" [showMinimize]="false">
  <form [formGroup]="formItem" class="form" (ngSubmit)="salvarItem()">
    <div class="row">
      <app-combobox-produto
        [label]="'Produto'"
        class="form-group col-sm-8"
        [disableControl]="loading['item']"
        (ngModelChange)="produtoChanged($event)"
        formControlName="produtoId"
        [autofocus]="true"
        [startOpen]="!itemEdicao"
      >
      </app-combobox-produto>

      <div
        class="form-group col-sm-4"
        combobox
        rem5
        [type]="'unidade-medida'"
        [loading]="loading"
        [form]="formItem"
        formControlName="unidadeMedidaId"
        [disableControl]="loading['item']"
      ></div>
    </div>
    <div class="row">
      <div class="form-group col-sm-6">
        <label for="form_custo">Custo</label>
        <input
          id="form_custo"
          type="text"
          [options]="{ precision: precisaoPreco }"
          currencyMask
          inputmode="numeric"
          formControlName="custo"
          class="form-control"
          [readonly]="loading['item']"
        />
        <show-errors [control]="formItem.controls.custo"></show-errors>
      </div>

      <div class="form-group col-sm-6">
        <label for="form_preco" class="label-required">Preço</label>
        <input
          id="form_preco"
          type="text"
          formControlName="preco"
          [options]="{ precision: precisaoPreco }"
          currencyMask
          inputmode="numeric"
          currencyFocus
          class="form-control"
          [readonly]="loading['item']"
        />
        <show-errors [control]="formItem.controls.preco"></show-errors>
      </div>
    </div>

    <div class="form-button-row">
      <button class="btn btn-primary" [disabled]="loading['salvando'] || loading['item']">
        <app-loading
          [texto]="titulo"
          textoLoading="Salvando"
          [loading]="loading['salvando']"
          icone="fa fa-plus"
        ></app-loading>
      </button>

      <button
        type="button"
        (click)="cancelar()"
        class="btn btn-danger"
        [disabled]="loading['salvando']"
      >
        <i class="fa fa-close"></i> Cancelar
      </button>
    </div>
  </form>
</app-card>
